import { useState } from "react";
import { useNavigate } from "react-router";

export default function Main() {
	const [ streamer, setStreamer ] = useState( '' );
	const navigate = useNavigate();

	function handleSubmit( e ) {
		e.preventDefault();
		navigate( `/${ streamer }` );
	}

	return (
		<main>
			<h1>Viewers</h1>
			Enter the streamer's room name:
			<form onSubmit={ handleSubmit }>
				<input
					type='text'
					value={ streamer }
					onChange={ e => setStreamer( e.target.value ) }
				/>
				<button
					type="submit"
				>
					Go
				</button>
			</form>

			<h1>Streamers</h1>
			<button>Login</button>
			<button>Register</button>
		</main>
	);
}